export default "__VITE_ASSET__JK4ysREn__"